<template>
  <div :class="$route.name">
    <Header />
    <div
      id="app-layout"
      class="py-4"
    >
      <div
        class="container"
        sticky-container
      >
        <div class="row">
          <div class="col-12 col-md-7">
            <article class="articles mb-3">
              <transition
                :name="transitionName"
                mode="out-in"
              >
                <router-view />
              </transition>
            </article>
            <SimilarArticles />
          </div>
          <div class="col-12 col-md-5">
            <BlogSidebar
              v-sticky
              sticky-offset="offset"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import BlogSidebar from '@/components/BlogSidebar';
import SimilarArticles from '@/components/SimilarArticles';

const DEFAULT_TRANSITION = 'slide';

export default {
  components: {
    Header,
    Footer,
    BlogSidebar,
    SimilarArticles
  },
  
  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      offset: { top: 30, bottom: 30 },
    }
  },

  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },

  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },
  }
}
</script>
<style lang="scss" scoped>
  #app-layout {
    padding: 20px 0;
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition-duration: 0.3s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    transform: translate(2em, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    transform: translate(-2em, 0);
  }

</style>

